import { useEffect } from 'react'
import Header from '../components/Header'
import Hero from '../components/Hero'
import About from '../components/About'
import Products from '../components/Products'
import Services from '../components/Services'
import Footer from '../components/Footer'
import Testimonials from '../components/Testimonials'
import Blogs from '../components/Blogs'
import Contact from '../components/Contact'
import Industries from '../components/Industries'
import GlobalReach from '../components/GlobalReach'

const HomePage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <title>Software Company Kerala | Web, POS &amp; IT Solutions India | Scalizap</title>
      <meta name="description" content="Scalizap is a leading software company in Kerala, India offering custom software development, web & mobile app development, POS systems, cloud solutions, AI development, and IT consulting services." />
      <Header />
      <Hero />
      <Services />
      <Industries />
      <Products />
      <GlobalReach />
      <Blogs />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  )
}

export default HomePage
